<template>
    <div class="pages__open__edit">
            <div class="pages__open__edit__header">
                <h3 :class="cardStatus">{{ dag }}</h3>
                <div class="pages__open__edit__header__switch" @click="click_switch">
                    <div :class="switchButton"></div>
                </div>
            </div>
            <div class="pages__open__edit__time" v-if="day.open == 1">
                <label for="">Van</label>
                <input type="date" v-model="day.start" v-on:change="$emit('edit_day', this.day)">
                <label for="">Tot</label>
                <input type="date" v-model="day.end" v-on:change="$emit('edit_day', this.day)">
            </div>
            <div :class="cardStatus" class="pages__open__edit__time" v-if="day.open == 0">
                <label for="">Van</label>
                <input type="time" disabled>
                <label for="">Tot</label>
                <input type="time" disabled>
            </div>
            <p :class="cardStatus" v-if="day.open == 0">Normale openingsuren</p>
            <p v-if="day.open == 1">{{ day.dag }} van {{ day.start }} tot {{ day.end }}</p>
        </div>
</template>
<script>
export default {
    props:["d_id", "dag", "open", "start", "end"],
    data(){
        return{
            day:{
                id: this.$props.d_id,
                dag: this.$props.dag,
                open: this.$props.open,
                start: this.$props.start,
                end: this.$props.end
            },
            switchButton: "pages__open__edit__header__switch__button",
            cardStatus: ""
        }
    },
    created(){
        if(this.day.open == 1){
            this.switchButton = "pages__open__edit__header__switch__button active";
            this.cardStatus = ""
        } else if(this.day.open == 0) {
            this.switchButton = "pages__open__edit__header__switch__button"
            this.cardStatus = "open__close"

        }
    },
    methods:{
        click_switch(){
            if(this.day.open == 1){
                this.day.open = 0;
                this.switchButton = "pages__open__edit__header__switch__button";
                this.cardStatus = "open__close";
                this.$emit('edit_day', this.day);
            } else{
                this.day.open = 1;
                this.switchButton = "pages__open__edit__header__switch__button active"
                this.cardStatus = "";
                this.$emit('edit_day', this.day);
            }
        }
    }
}
</script>